import { FC } from 'react';

import { Box, Stack } from '@mui/material';
import { IDictionaryItem } from 'api/types';
import { useAppSelector } from 'hooks';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';

import { checkChosenOptionsFilter } from '../../utils/filters';
import FiltersContainer from './FiltersContainer';
import { CollegeFilter, DistrictFilter, IndustryFilter, SpecialityFilter } from './specificFilters';

interface IRecommendationProbesFiltersProps {
  industryOptions: IDictionaryItem[];
  specialityOptions: IDictionaryItem[];
  collegeOptions: IDictionaryItem[];
  districtOptions: IDictionaryItem[];
}

const RecommendationProbesFilters: FC<IRecommendationProbesFiltersProps> = ({
  industryOptions,
  specialityOptions,
  collegeOptions,
  districtOptions,
}) => {
  const filters = useAppSelector((state) => state.proforientationRecommendationFilters);

  const industryControl = <IndustryFilter section="probes" options={industryOptions} />;
  const specialityControl = <SpecialityFilter section="probes" options={specialityOptions} />;
  const collegeControl = <CollegeFilter section="probes" options={collegeOptions} />;
  const districtControl = <DistrictFilter section="probes" options={districtOptions} />;

  const handleFiltersApply = () => {
    const chosenIndustries = industryOptions
      .filter((industry) => checkChosenOptionsFilter(industry.code, filters['probes/industry']))
      .map((item) => item.value);
    const chosenSpecialities = specialityOptions
      .filter((speciality) => checkChosenOptionsFilter(speciality.code, filters['probes/speciality']))
      .map((item) => item.value);
    const chosenColleges = collegeOptions
      .filter((college) => checkChosenOptionsFilter(college.code, filters['probes/college']))
      .map((item) => item.value);
    const chosenDistricts = districtOptions
      .filter((district) => checkChosenOptionsFilter(district.code, filters['probes/district']))
      .map((item) => item.value);

    emitYMEvent({
      type: 'samplesTab_startSearching_click',
      payload: {
        industry: chosenIndustries.toString(),
        speciality: chosenSpecialities.toString(),
        college: chosenColleges.toString(),
        district: chosenDistricts.toString(),
      },
    });
  };

  const handleFiltersClick = () => {
    emitYMEvent({ type: 'samplesTab_filters_click' });
  };

  const handleFiltersReset = () => {
    emitYMEvent({ type: 'samplesTab_resetAll_click' });
  };

  return (
    <FiltersContainer
      sectionKey="probes"
      controlKeys={['industry', 'speciality', 'college', 'district']}
      onFiltersApply={handleFiltersApply}
      onFiltersClick={handleFiltersClick}
      onFiltersReset={handleFiltersReset}
    >
      <Stack gap="12px">
        <Box className="row" sx={{ display: 'flex', gap: '12px' }}>
          {industryControl}
          {specialityControl}
        </Box>
        <Box className="row" sx={{ display: 'flex', gap: '12px' }}>
          {collegeControl}
          {districtControl}
        </Box>
      </Stack>
    </FiltersContainer>
  );
};

export default RecommendationProbesFilters;
